<app-inner-box>
  <app-subpage-header title="Produktionsübersicht"></app-subpage-header>
  <br>
  <app-list></app-list>
</app-inner-box>
